import FilterAttributeMethods from '@ve/components/filters/common/filterMethods/filterAttributeMethodsHotelNumber/FilterAttributeMethodsHotelNumber';
import { IBeachLine } from '../types';
import dataBeachLines from './dataBeachLineAttributes';

const BeachLineAttributeMethods = new FilterAttributeMethods<IBeachLine>(dataBeachLines, 'beachLine').setFilterName('Линия пляжа');

export default BeachLineAttributeMethods;